import React from "react"
import tw, { css } from "twin.macro"

interface SpeedoLabelProps {
  selected?: boolean
  hours: number
  onClick: () => void
}

const SpeedoLabelButton: React.FC<SpeedoLabelProps> = ({
  selected,
  hours,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      css={[
        css`transform: translateX(-50%)`,
        tw`font-licenz flex flex-col items-center opacity-50 hover:opacity-100 focus:outline-none`,
        selected && tw`opacity-100`,
      ]}
    >
      <span css={[tw`text-2xl md:text-4xl -mb-2`]}>{hours}H</span>
      <span
        css={[
          css`
            font-size: 0.6875rem;
          `,
          tw`tracking-wider`,
        ]}
      >
        week
      </span>
    </button>
  )
}

export default SpeedoLabelButton
